import { Component, HostListener, OnInit } from '@angular/core';

import { detectBody } from 'src/app/shared/app.helpers';

declare var jQuery: any;

@Component({
  selector: 'app-top-navigation-layout',
  templateUrl: 'topNavigationLayout.template.html',
})
export class TopNavigationLayoutComponent implements OnInit {
  public ngOnInit(): any {
    detectBody();
  }

  @HostListener('window:resize') onResize() {
    detectBody();
  }
}
